import moment from "moment";

const formatDate = (date) => (date ? moment(date, "YYYY-MM-DD").format("DD/MM/YYYY") : "");

export default formatDate;
